import { PublicApiRequestStatusEnum } from '@api/enum';
import { getMultiImageLogs, getPublicApiLogs } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useCallback, useMemo, useState } from 'react';

const usePublicApiLogsListData = (startDate: string, endDate: string, initialFilter: string = 'ALL') => {
    const [filterValue, setFilterValue] = useState(initialFilter);

    const changeFilterValue = useCallback((val: string | number) => {
        setFilterValue(val as PublicApiRequestStatusEnum | 'ALL');
    }, []);

    const logsQuery = useDataQuery(['public-api-logs', startDate, endDate], () => getPublicApiLogs(startDate, endDate));

    const allLogs = logsQuery.data || [];

    const filteredLogs = useMemo(() => {
        if (logsQuery.isLoading) return [];
        return filterValue === 'ALL'
            ? allLogs
            : allLogs.filter((log: { status: string }) => log.status === filterValue);
    }, [logsQuery.isLoading, filterValue, allLogs]);

    const statusCounts = useMemo(() => {
        const counts: Record<PublicApiRequestStatusEnum, number> = {
            [PublicApiRequestStatusEnum.PENDING]: 0,
            [PublicApiRequestStatusEnum.COMPELETED]: 0,
        };

        for (const log of allLogs) {
            const status = log.status as PublicApiRequestStatusEnum;
            if (status in counts) {
                counts[status]++;
            }
        }

        return {
            ...counts,
            ALL: allLogs.length,
        };
    }, [allLogs]);

    return {
        data: filteredLogs,
        isLoading: logsQuery.isLoading,
        filterValue,
        changeFilterValue,
        statusCounts,
    };
};

export default usePublicApiLogsListData;
